<!--
<div class="custom-slider">
	<ng5-slider [options]="options" [formControl]="parentForm.get(formControlName)"></ng5-slider>
</div>
-->

<div class="custom-slider" [ngClass]="{'promo-selected': parentForm.get(formControlName).value === promoValue, 'is-loading': disabled  }">
	<ng5-slider [options]="options" [formControl]="parentForm.get(formControlName)" [manualRefresh]="manualRefresh" (userChangeEnd)="INDRA_onChange()">
		  <ng-template #tooltipTemplate let-tooltip="tooltip" let-placement="placement" let-content="content">
				<div class="slider-tooltip" [tooltip]=tooltip></div>
			</ng-template>
	</ng5-slider>
</div>
